import React, { useMemo } from "react";
import { Table } from "ui";
import { checkout } from "../type";
import { processCodeMessage } from "../utils";
import moment from "moment-jalaali";
import { CHECKOUTS_TABLE_COLUMN } from "../constant";

interface checkoutsTableProp {
  checkouts?: checkout[];
  isLoading?: boolean;
  error?: string | null;
  page: number;
  pageSize: number;
}
export const CheckoutsTable: React.FC<checkoutsTableProp> = ({
  checkouts,
  isLoading,
  error,
  page,
  pageSize,
}) => {
  const data = useMemo(() => {
    return checkouts?.map((item, i) => {
      return {
        $: i + 1 + pageSize * (page - 1),
        amount: item.amount.toLocaleString() || "-",
        date: item.dateFa || "-",
        trackingNumber: item.trackingNumber || "-",
        acceptorCode: item.acceptorCode || "-",
        transactionId: item.transactionId || "-",
        acceptorWageAmount: item.acceptorWageAmount.toLocaleString() || "-",
        isProcess: !item.isProcess
          ? "عدم تصویه"
          : processCodeMessage(item.processCode),
        processDate: item?.processDate
          ? moment(item?.processDate).format("HH:mm:ss jYYYY/jMM/jDD ")
          : "-",
      };
    });
  }, [checkouts, page, pageSize]);
  if (!!error) {
    return <div className="w-100 flex-center text-danger">{error}</div>;
  } else {
    return (
      <>
        <Table
          isLoading={isLoading}
          columns={CHECKOUTS_TABLE_COLUMN}
          data={data}
          getRowCanExpand={() => true}
        />
      </>
    );
  }
};
